import { render, staticRenderFns } from "./CollectionShowcase.vue?vue&type=template&id=46e7b410&scoped=true&"
import script from "./CollectionShowcase.vue?vue&type=script&lang=js&"
export * from "./CollectionShowcase.vue?vue&type=script&lang=js&"
import style0 from "./CollectionShowcase.vue?vue&type=style&index=0&id=46e7b410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e7b410",
  null
  
)

export default component.exports